import React, { useEffect, useRef } from 'react';

import moment from 'moment';
import { useState } from 'react';
import {
  selectPrefix,
  selectStationId,
  selectStationName,
  selectUserType,
  selectWidth,
  selectreportFromDate,
  selectreportToDate,
  setreportsFromDate,
  setreportsTodate,
} from '../../utility/Redux/profile';
import { useDispatch, useSelector } from 'react-redux';
import { selectToken } from '../../utility/Redux/security';

import {
  selectCollectionAccountDetails,
  setCollectionAccountDetails,
  setItemMasterHelpStatus,
  setListStationMasterModalStatus,
  setModPartyMasterHelpStatus,
  setSessionExpired,
  setloading,
} from '../../utility/Redux/modal';

import axios from 'axios';
import { FormatNumber2, FormatNumber3 } from '../../utility/component/tools';

import { setStationID } from '../../utility/Redux/profile';
import { setStationName } from '../../utility/Redux/profile';
import ModListStationMaster from '../../utility/component/modals/modListStationMaster';
import { FromToDate } from '../../utility/component/fromToDate';
import ItemMasterHelp from '../../master/iteemMasterHelp';
import GeniusReportsDate from '../../utility/component/reportDate';
import ReactToPrint from 'react-to-print';
import GeniusTableForReports from '../../utility/component/geniusComponents/geniusTableforReports';
import dataToLocal from '../../utility/functions/summaryToLocal';
import IsLocalData from '../../utility/functions/ceckLocalData';
import deleteWholeDatabase from '../../utility/functions/deleteWholeDatabase';
import { CallAPIPromise } from './dashboard/biiling/modal/comman';
import { NewFromToDate } from '../../utility/component/newFromToDate';
import ModAccountMasterCollectionVoucher from '../../utility/component/modals/modAccountMaster';
import ModPartyMasterHelp from '../../master/partyMasterHelp';
import ReportDataTable from '../../utility/component/datagrid/ReportDataTable';

const ItemWiseReport = () => {
  const token = useSelector(selectToken);
  const prefix = useSelector(selectPrefix);
  const ReduxStation_id = useSelector(selectStationId);
  const dispatch = useDispatch();
  const ReduxStationName = useSelector(selectStationName);
  const printRef = useRef();
  const [accountDeails, setAccountDetails] = useState("");
  const [itemDetails, setItemDetails] = useState("");
  const userType = useSelector(selectUserType);
  const firstDate = useSelector(selectreportFromDate);
  const SecondDate = useSelector(selectreportToDate);
  const [dataLoading, setDataLoading] = useState(false);
  const [list, setList] = useState([]);
  const [itemCode, setItemCode] = useState('');
  const width = useSelector(selectWidth);
  const [fromDateFocus, setFromDateFocus] = useState(false);
  const [stationDetails,setStationDetails]= useState("")
  const [toDateFocus, setToDateFocus] = useState(false);
  console.log(accountDeails)


  const getItemWiseReport = () => {
    console.log(accountDeails)
    setDataLoading(true);
    deleteWholeDatabase('Item_Wise_Sale_Report');
    CallAPIPromise(
      `/api/reports/itemSaleToParty`,
      {
        table_prefix: prefix,
        from_date: firstDate,
        to_date: SecondDate,
        SID: stationDetails?.CODE||"",
        ICODE: itemDetails?.ICODE||"" ,
        ACCOUNT_NO: accountDeails.ACCOUNT_NO || '',
      },
      token,
      dispatch
    )
      .then((res) => {
        if (!res.data.error) {
          const data = res.data.response;
          let rowList = [];

          for (let index = 0; index < data.length; index++) {
            rowList.push({
              ...data[index],
              id: index + 1,
            });
          }
          if (rowList[0]) {
            dataToLocal('Item_Wise_Sale_Report', rowList, [
              {
                table_prefix: prefix,
                from_date: firstDate,
                to_date: SecondDate,
                SID: ReduxStation_id,
                ICODE: itemCode ? itemCode : '',
                ACCOUNT_NO: accountDeails.accNumber ? accountDeails.accNumber : '',
              },
            ]);
          }
          setList(rowList);
        }
      })
      .catch((e) => {
        console.log(e);

        if (e.response.data.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
        }
      })
      .finally(() => {
        dispatch(setloading(false));
        setDataLoading(false);
      });
  };

  const okButton = () => {
    getItemWiseReport();
  };

  const columns = [
    {
      field: 'INVNO',
      type: 'number',
      accessor: 'INVNO',
      width: width < 1280 ? 100 : 100,
      headerAlign: 'center',
      align: 'left',
      valueFormatter: (param) => {
        return param.value;
      },
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex text-center">
          {' '}
          {'Invoice No.'}
        </div>
      ),
    },
    {
      field: 'DATE',
      accessor: 'DATE',
      type: 'date',
      width: width < 1280 ? 100 : 100,
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      valueFormatter: (params) => {
        if (params.value) {
          return moment(params.value).format('DD-MM-YYYY');
        } else {
          return '';
        }
      },

      renderHeader: (params) => <div style={{ fontSize: 12 }}>{'Date'}</div>,
    },

    {
      field: 'ITEMNAME',
      accessor: 'ITEMNAME',
      type: 'string',
      width: width < 1280 ? 150 : 200,
      headerAlign: 'center',
      align: 'left',

      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div
          style={{ fontSize: 12 }}
          className="whitespace-normal leading-4 flex text-center"
        >
          {'Item Name'}
        </div>
      ),
    },

    {
      field: 'ACCOUNT_NO',
      accessor: 'ACCOUNT_NO',
      type: 'string',
      width: width < 1280 ? 100 : 100,
      headerAlign: 'center',
      align: 'left',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div
          style={{ fontSize: 12 }}
          className="whitespace-normal leading-4 flex text-center"
        >
          {'Acc. No.'}
        </div>
      ),
    },

    {
      field: 'NAME',
      accessor: 'NAME',
      type: 'string',
      width: width < 1280 ? 180 : 200,
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div style={{ fontSize: 12 }}>{'Party Name'}</div>
      ),
    },
    {
      field: 'MOBILE',
      accessor: 'MOBILE',
      type: 'number',
      width: width < 1280 ? 100 : 100,
      headerAlign: 'center',
      align: 'left',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div
          style={{ fontSize: 12 }}
          className="whitespace-normal leading-4 flex text-center"
        >
          {'Mobile'}
        </div>
      ),
    },

    {
      field: 'SQNTY',
      accessor: 'SQNTY',
      type: 'string',
      width: width < 1280 ? 100 : 100,
      align: 'right',
      valueFormatter: (params) => {
        if (params.value) {
          return FormatNumber3(params.value);
        } else {
          return '';
        }
      },
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div style={{ fontSize: 12 }}>{'Sales Qnty'}</div>
      ),
    },
    {
      field: 'SALE_PRICE',
      accessor: 'SALE_PRICE',
      type: 'string',
      width: width < 1280 ? 100 : 100,
      align: 'right',
      valueFormatter: (params) => {
        if (params.value) {
          return FormatNumber2(params.value);
        } else {
          return '';
        }
      },
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div style={{ fontSize: 12 }}>{'Sale Price'}</div>
      ),
    },
    {
      field: 'AMOUNT',
      accessor: 'AMOUNT',
      type: 'string',
      width: width < 1280 ? 100 : 100,
      align: 'right',
      valueFormatter: (params) => {
        if (params.value) {
          return FormatNumber2(params.value);
        } else {
          return '';
        }
      },
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => <div style={{ fontSize: 12 }}>{'Amount'}</div>,
    },
    {
      field: 'HSN_CODE',
      accessor: 'HSN_CODE',
      type: 'string',
      width: width < 1280 ? 100 : 100,
      align: 'left',
      renderHeader: (params) => (
        <div style={{ fontSize: 12 }}>{'HSN Code'}</div>
      ),

      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
    },

    {
      field: 'TAX1_RATE',
      accessor: 'TAX1_RATE',
      type: 'string',
      width: width < 1280 ? 100 : 100,
      align: 'right',
      renderHeader: (params) => <div style={{ fontSize: 12 }}>{'CGST %'}</div>,
      renderCell: (params) => {
        if (params.value) {
          return <div className=""> {FormatNumber2(params.value)} </div>;
        } else {
          return '';
        }
      },

      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
    },
    {
      accessor: 'TAX1_AMT',
      field: 'TAX1_AMT',
      type: 'string',
      width: width < 1280 ? 100 : 100,
      align: 'right',
      renderCell: (params) => {
        if (params.value) {
          return <div className=" "> {FormatNumber2(params.value)} </div>;
        } else {
          return '';
        }
      },

      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div style={{ fontSize: 12 }}>{'CGST Amt.'}</div>
      ),
    },
    {
      accessor: 'TAX2_RATE',
      field: 'TAX2_RATE',
      type: 'string',
      width: width < 1280 ? 100 : 100,
      align: 'right',
      renderCell: (params) => {
        if (params.value) {
          return <div className=" "> {FormatNumber2(params.value)} </div>;
        } else {
          return '';
        }
      },

      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => <div style={{ fontSize: 12 }}>{'SGST %'}</div>,
    },
    {
      accessor: 'TAX2_AMT',
      field: 'TAX2_AMT',
      type: 'string',
      width: width < 1280 ? 100 : 100,
      align: 'right',
      renderCell: (params) => {
        if (params.value) {
          return <div className=" "> {FormatNumber2(params.value)} </div>;
        } else {
          return '';
        }
      },

      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div style={{ fontSize: 12 }}>{'SGST Amt.'}</div>
      ),
    },

    {
      field: 'TAX3_RATE',
      accessor: 'TAX3_RATE',
      type: 'string',
      width: width < 1280 ? 100 : 100,
      align: 'right',
      renderCell: (params) => {
        if (params.value) {
          return <div className=" "> {FormatNumber2(params.value)} </div>;
        } else {
          return '';
        }
      },

      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => <div style={{ fontSize: 12 }}>{'IGST %'}</div>,
    },
    {
      field: 'TAX3_AMT',
      accessor: 'TAX3_AMT',
      type: 'string',
      width: width < 1280 ? 100 : 100,
      align: 'right',
      renderCell: (params) => {
        if (params.value) {
          return (
            <div style={{ fontSize: 12 }}>{FormatNumber2(params.value)}</div>
          );
        } else {
          return '';
        }
      },

      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div style={{ fontSize: 12 }}>{'IGST Amt.'}</div>
      ),
    },
    {
      field: 'TOTAL_AMOUNT',
      accessor: 'TOTAL_AMOUNT',
      type: 'string',
      width: width < 1280 ? 100 : 100,
      align: 'right',
      renderCell: (params) => {
        const totalAmt =
          params.row.AMOUNT +
          params.row.TAX1_AMT +
          params.row.TAX2_AMT +
          params.row.TAX3_AMT;
        if (totalAmt) {
          return <div style={{ fontSize: 12 }}>{FormatNumber2(totalAmt)}</div>;
        } else {
          return '';
        }
      },

      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div style={{ fontSize: 12 }}>{'Total Amt.'}</div>
      ),
    },
  ];

  useEffect(() => {
    const callback = (details, data) => {
      setList(data);
      dispatch(setStationID(details[0].SID));
      dispatch(setItemCode(details[0].ICODE));
      dispatch(
        setreportsTodate(moment(details[0].to_date).format('YYYY-MM-DD'))
      );

      dispatch(
        setreportsFromDate(moment(details[0].from_date).format('YYYY-MM-DD'))
      );
    };
    const elseFunc = () => {
      dispatch(
        setCollectionAccountDetails({
          accName: '',
          accAddress: '',
          accMobile: '',
          accNumber: '',
          stationId: '',
        })
      );
      if (userType !== 'USER') {
        dispatch(setStationID(''));
        dispatch(setStationName(''));
      }
    };
    IsLocalData('Item_Wise_Sale_Report', callback, elseFunc);
  }, []);
  const totalSaleQnty = list.reduce((total, row) => total + Number(row.SQNTY || 0), 0);
  const totalAmount = list.reduce((total, row) => total + Number(row.AMOUNT || 0), 0);
  const totalCGST = list.reduce((total, row) => total + Number(row.TAX1_AMT || 0), 0);
  const totalSGST = list.reduce((total, row) => total + Number(row.TAX2_AMT || 0), 0);
  const totalIGST = list.reduce((total, row) => total + Number(row.TAX3_AMT || 0), 0);
  const totalAMT = list.reduce(
    (total, row) =>
      total +
      Number(row.AMOUNT || 0) +
      Number(row.TAX1_AMT || 0) +
      Number(row.TAX2_AMT || 0) +
      Number(row.TAX3_AMT || 0),
    0
  );

  return (
    <div className="p-1 w-full h-full items-center ">
      {window.innerWidth <= 500 ? (
        <>
          <div
            style={{
              border: '1px solid #b5b3b3',
            }}
            className="p-1 py-3 rounded-t-sm  flex items-center "
          >
            <div className="px-1 ">From</div>

            <GeniusReportsDate
              date={firstDate}
              onChange={(e) => {
                dispatch(setreportsFromDate(moment(e).format('YYYY-MM-DD')));
                setFromDateFocus(false);
              }}
              dateFocus={fromDateFocus}
              SetDateFocus={setFromDateFocus}
            />
            <div className="px-1 pl-2 ">To</div>
            <GeniusReportsDate
              date={SecondDate}
              onChange={(e) => {
                dispatch(setreportsTodate(moment(e).format('YYYY-MM-DD')));
                setToDateFocus(false);
              }}
              dateFocus={toDateFocus}
              SetDateFocus={setToDateFocus}
            />
          </div>

          <div style={{ border: '1px solid #b5b3b3', borderTop: '0px' }}>
            {userType === 'USER' ? null : (
              <div className="flex  text-[#4B4545] p-2  ">
                <div
                  onClick={() => {
                    if (userType === 'MANAGER' ||userType === 'STORE' ) {
                      dispatch(setListStationMasterModalStatus(true));
                    }
                  }}
                  style={{ fontSize: 13 }}
                  className=" flex whitespace-normal  justify-center items-center hover:cursor-pointer "
                >
                  <div className="flex items-center ">
                    <div>
                      <i
                        className="bi bi-search"
                        style={{ color: '#f44336', fontSize: 15 }}
                      ></i>
                    </div>

                    <span
                      style={{ fontSize: 12, fontWeight: 600 }}
                      className=" text-[#5c5b5b] pl-2 whitespace-nowrap  items-center"
                    >
                      Station ID
                    </span>
                  </div>

                  <div
                    style={{
                      border: '1px dotted #a6a2a2 ',
                      borderRadius: '3px',
                    }}
                    className="flex text-[#a6a2a2]  pl-2 ml-3  "
                  >
                    <input
                      size={'small'}
                      placeholder="All"
                      value={ReduxStation_id ? ReduxStation_id : 'All'}
                      style={{
                        // width: '20%',
                        fontSize: 13,
                        paddingTop: '2px',
                        paddingBottom: '2px',
                        backgroundColor: 'transparent',
                      }}
                      readOnly
                      className=" outline-0 w-6"
                    />

                    <div
                      style={{
                        borderLeft: '1px dotted #a6a2a2 ',
                      }}
                      className="px-2 p-1 w-52 whitespace-nowrap print:hidden"
                    >
                      {ReduxStationName ? `${ReduxStationName}` : null}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {
              <div className="flex   text-[#4B4545]  border-t border-[#b5b3b3] py-2 px-2">
                <div
                  style={{ fontSize: 13 }}
                  className=" flex whitespace-normal  justify-center items-center hover:cursor-pointer "
                >
                  <div
                    onClick={() => dispatch(setItemMasterHelpStatus(true))}
                    className="flex items-center "
                  >
                    <div>
                      <i
                        className="bi bi-search"
                        style={{ color: '#f44336', fontSize: 15 }}
                      ></i>
                    </div>

                    <span
                      style={{ fontSize: 12, fontWeight: 600 }}
                      className=" text-[#5c5b5b] pl-2 whitespace-nowrap  items-center"
                    >
                      Item Code
                    </span>
                  </div>

                  <div
                    style={{
                      border: '1px dotted #a6a2a2 ',
                      borderRadius: '3px',
                    }}
                    className="px-2 p-1 ml-3 w-auto text-[#a6a2a2] whitespace-nowrap print:hidden  flex justify-center"
                  >
                    <div>{itemCode ? itemCode : 'All'}</div>
                  </div>
                  <div>
                    <button
                      onClick={okButton}
                      className="flex items-center rounded-sm ml-2"
                      style={{
                        backgroundColor: '#c1c1c1',
                        paddingLeft: 30,
                        paddingRight: 30,
                        paddingTop: 4,
                        paddingBottom: 4,
                        color: 'black',
                      }}
                    >
                      <div className="flex items-center text-sm">Ok</div>
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>
        </>
      ) : (
        // <FromToDate
        //     submit={okButton}
        //     onPartySearchClick={() => {
              
        //     }}
        //   itemCode={{
        //     itemCode: itemCode,
        //     setItemCode: setItemCode,
        //     status: true,
        //   }}
        //   otherButton={
        //     list[0] && width > 1024 ? (
        //       <ReactToPrint
        //         trigger={() => {
        //           return (
        //             <button
        //               style={{
        //                 width: 'auto',
        //                 borderRadius: '7px',
        //                 height: 'auto',
        //                 paddingLeft: 30,
        //                 paddingRight: 30,
        //                 paddingTop: 4,
        //                 paddingBottom: 4,
        //                 backgroundColor: '#bad4f9',
        //                 color: 'black',
        //                 marginLeft: 7,
        //               }}
        //             >
        //               <div className="text-sm">Print</div>
        //             </button>
        //           );
        //         }}
        //         content={() => printRef.current}
        //       />
        //     ) : (
        //       false
        //     )
        //   }
            
        //   reset={() => {
        //     if (userType === 'USER') {
        //       dispatch(
        //         setCollectionAccountDetails({
        //           accName: '',
        //           accAddress: '',
        //           accMobile: '',
        //           accNumber: '',
        //           stationId: '',
        //         })
        //       );
        //       setItemCode('');
        //     } else {
        //       setItemCode('');
        //       dispatch(setStationID(''));
        //       dispatch(setStationName(''));
        //       dispatch(
        //         setCollectionAccountDetails({
        //           accName: '',
        //           accAddress: '',
        //           accMobile: '',
        //           accNumber: '',
        //           stationId: '',
        //         })
        //       );
        //     }
        //   }}
          // />
          <div className='w-full '>
            <NewFromToDate submit={() => {
              okButton()
   }}   partyData={{
            NAME: accountDeails?.NAME,
            }}
              otherButton={
                <ReactToPrint
                  trigger={() => {
                    return (
                      <button
                        className="mr-2 flex h-8 items-center rounded-sm px-5 text-sm shadow-sm"
                        style={{
                          backgroundColor: '#93c5fd',
                          color: 'black',
                        }}
                      >
                        <i className="bi bi-printer pr-2"></i>
                        Print
                      </button>
                    );
                  }}
                  content={() => printRef.current}
                />
              }
              itemData={{
                ICODE: itemDetails?.ICODE||"",
                ITEMNAME:itemDetails?.ITEMNAME||""
              }}
              onStationClick={() => {
              dispatch(setListStationMasterModalStatus(true))
              }}
              itemClear={() => {
                setItemDetails("")
              }}
            
          onPartyMasterSearchClick={() => {
           dispatch(setModPartyMasterHelpStatus(true))
              }} partyClear={() => {
              setAccountDetails("")
            }} onItemClick={() => {
            dispatch(setItemMasterHelpStatus(true))
              }} stationData={stationDetails} clearStation={() => {
            setStationDetails("")
          }} hideReset={true}/>
          </div>
       
      )}

      <div
        style={{
          marginTop: 10,
          height: `calc(100% - ${window.innerWidth < 500 ? 250 : 200}px)`,
        }}
      >
        <ReportDataTable
          columns={columns}
          rows={list}
          loading={dataLoading}
          getRowKey={(row) => row.id}
          emptyTitle="No item wise sale data found"
          emptyDescription="Select filters and run the report to view item sales."
          footerValue={(column) => {
            if (column.field === 'ITEMNAME') return 'Grand Total';
            if (column.field === 'SQNTY') return FormatNumber3(totalSaleQnty);
            if (column.field === 'AMOUNT') return FormatNumber2(totalAmount);
            if (column.field === 'TAX1_AMT') return FormatNumber2(totalCGST);
            if (column.field === 'TAX2_AMT') return FormatNumber2(totalSGST);
            if (column.field === 'TAX3_AMT') return FormatNumber2(totalIGST);
            if (column.field === 'TOTAL_AMOUNT') return FormatNumber2(totalAMT);
            return '';
          }}
        />
      </div>

      <div
        ref={printRef}
        style={{ width: '100%', display: 'block', visibility: 'hidden' }}
      >
        <GeniusTableForReports
          stationId={ReduxStation_id}
          date={firstDate}
          date1={SecondDate}
          columns={columns}
          data={list}
          // Fotter={
          //   <ItemWiseFooter
          //     rows={list}
          //     columns={
          //       window.innerWidth <= 500
          //         ? columnsMobile
          //         : window.innerWidth <= 1280
          //         ? columnsTab
          //         : columns
          //     }
          //   />
          // }
          title={'Item Wise Report'}
        />
      </div>

      <ModListStationMaster
        onRowClick={(p) => {
          setStationDetails(p.row)
          setAccountDetails("")
          setItemDetails("")
          // dispatch(setStationID(p.row.CODE));
          // dispatch(setStationName(p.row.STATION_NAME));
          dispatch(setListStationMasterModalStatus(false));
        }}
      />
      <ItemMasterHelp
        onRowClick={(p) => {
          setItemCode(p.row.ICODE);
          setItemDetails(p.row)
          setAccountDetails("")
          setStationDetails("")
          dispatch(setItemMasterHelpStatus(false));
        }}
        setItemCode={setItemCode}
      />
        <ModPartyMasterHelp
        onRowClick={(p) => {
          dispatch(setModPartyMasterHelpStatus(false));
          setAccountDetails(p.row);
          setItemDetails("")
          setStationDetails("")
        }}
        onClose={() => {
          dispatch(setModPartyMasterHelpStatus(false));
        }}
      />
    </div>
  );
};

export default ItemWiseReport;
